/**
 * Menu lateral por papel — mesma montagem do `_visible_pages()` do app.py antigo.
 *
 * Cada item aponta para uma rota em `src/routes/_painel/`. Para trocar título
 * ou ordem do menu, mude aqui; o conteúdo de cada página fica no arquivo dela.
 */

export interface PaginaMenu {
  /** Caminho da rota (caminho antigo do painel). */
  caminho: string
  /** Texto do item no menu. */
  titulo: string
}

export interface SecaoMenu {
  nome: string
  paginas: PaginaMenu[]
}

export const PAGINA_INICIAL: PaginaMenu = { caminho: '/', titulo: 'Início' }

/** Página de chamado: fora do menu, mas acessível a quem entra no painel. */
export const CAMINHO_CHAMADO = '/chamado'

const PAGINAS_DIA_A_DIA: PaginaMenu[] = [
  PAGINA_INICIAL,
  { caminho: '/violacoes_usuario', titulo: 'Suas violações' },
]

const PAGINA_REGRAS: PaginaMenu = { caminho: '/regras', titulo: 'Regras' }

const PAGINAS_GOVERNANCA_GESTAO: PaginaMenu[] = [
  { caminho: '/violacoes', titulo: 'Violações' },
  { caminho: '/webhooks', titulo: 'Webhooks' },
  { caminho: '/milestone_dashboard', titulo: 'Dashboard de Milestone' },
  { caminho: '/merge_por_epico', titulo: 'Merge por épico ou milestone' },
]

const PAGINAS_QUALIDADE: PaginaMenu[] = [
  // Já migrada (Qualidade › Wikis): fica aqui só para conferir o papel de quem abre um link antigo.
  { caminho: '/julgamentos_wiki', titulo: 'Julgamentos de Wikis' },
  { caminho: '/julgamentos_qa', titulo: 'Julgamentos de QA' },
  { caminho: '/notas_qa', titulo: 'Notas de QA' },
  { caminho: '/metricas_de_qa', titulo: 'Métricas de QA' },
]

const PAGINAS_ADMINISTRACAO: PaginaMenu[] = [
  { caminho: '/gerenciar_usuarios', titulo: 'Gerenciar usuários' },
  { caminho: '/vinculo_emails_commit', titulo: 'Vínculo e-mails de commit' },
  { caminho: '/correlacao_projetos_times', titulo: 'Correlação projetos e times' },
  { caminho: '/configuracao_grupos_e_projetos', titulo: 'Configuração grupos e projetos' },
  { caminho: '/configuracoes_globais', titulo: 'Configurações globais' },
  { caminho: '/responsaveis_email', titulo: 'Responsáveis por e-mail' },
  { caminho: '/custos_llm', titulo: 'Uso de IA' },
  { caminho: '/labels_isentas', titulo: 'Labels isentas' },
  { caminho: '/erros', titulo: 'Erros' },
]

/** Monta o menu lateral por domínio, sem seções vazias, conforme os papéis. */
export function secoesVisiveis(papeis: ReadonlySet<string>): SecaoMenu[] {
  const diaADia: PaginaMenu[] = []
  const governanca: PaginaMenu[] = []
  const qualidade: PaginaMenu[] = []
  const administracao: PaginaMenu[] = []

  const temAlgum = (lista: string[]) => lista.some((p) => papeis.has(p))

  if (temAlgum(['user', 'manager', 'admin'])) {
    diaADia.push(...PAGINAS_DIA_A_DIA)
    governanca.push(PAGINA_REGRAS)
  }
  if (temAlgum(['manager', 'admin'])) {
    governanca.push(...PAGINAS_GOVERNANCA_GESTAO)
    qualidade.push(...PAGINAS_QUALIDADE)
  }
  if (papeis.has('admin')) {
    administracao.push(...PAGINAS_ADMINISTRACAO)
  }

  const secoes: SecaoMenu[] = [
    { nome: 'Dia a dia', paginas: diaADia },
    { nome: 'Governança', paginas: governanca },
    { nome: 'Qualidade', paginas: qualidade },
    { nome: 'Administração', paginas: administracao },
  ].filter((s) => s.paginas.length > 0)

  if (secoes.length === 0) return [{ nome: 'Dia a dia', paginas: [PAGINA_INICIAL] }]
  return secoes
}

/** True se o caminho pode ser aberto com esses papéis (menu + página oculta de chamado). */
export function caminhoPermitido(caminho: string, secoes: SecaoMenu[]): boolean {
  if (caminho === CAMINHO_CHAMADO) return true
  return secoes.some((s) => s.paginas.some((p) => p.caminho === caminho))
}
